import React from "react";
import { Link } from "react-router-dom";
import { regionNav } from "./navdata.js";

/**
 * Desktop "Data by Region" panel: 3 equal columns, each region block has its
 * icon + name (linking to the region landing page) and its sub-regions in an
 * internal 2-column list. The sixth grid cell is intentionally left blank.
 *
 * @param props.onNavigate Called when any link is activated
 * @return JSX element
 */
export function RegionMegaMenu({ onNavigate }) {
  return (
    <div className="regionMegaMenu">
      {regionNav.map((region) => (
        <div className="regionMegaBlock" key={region.key}>
          <Link
            to={region.landingPath}
            className="regionMegaHead"
            onClick={onNavigate}
          >
            <span className="navRegionIcon">
              <img src={region.icon} alt="" aria-hidden="true" />
            </span>
            <span className="regionMegaName">{region.name}</span>
          </Link>
          <ul className="regionMegaSubs">
            {region.subRegions.map((sub) => (
              <li key={sub.path}>
                <Link to={sub.path} onClick={onNavigate}>
                  {sub.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
